const LocalStorageServices = (() => {
    const tokenObjName = 'jwtToken';

    const _getTokenItems = () => {
        const token = localStorage.getItem(tokenObjName);
        try {
            return token ? JSON.parse(token) : null;
        } catch (e) {
            return null;
        }
    };

    const _setToken = (tokenObj) => {
        localStorage.setItem(tokenObjName, tokenObj);
    };

    const _getAccessToken = () => {
        const tokenItems = _getTokenItems();
        return tokenItems ? tokenItems.value : null;
    };

    const _getRefreshToken = () => {
        const tokenItems = _getTokenItems();
        return tokenItems ? tokenItems.refresh : null;
    };

    const _getTokenExpirationTime = () => {
        const tokenItems = _getTokenItems();
        return tokenItems ? tokenItems.expiry : null;
    };

    const _clearToken = () => {
        localStorage.removeItem(tokenObjName);
    };

    return {
        setToken: _setToken,
        getAccessToken: _getAccessToken,
        getRefreshToken: _getRefreshToken,
        getTokenExpirationTime: _getTokenExpirationTime,
        clearToken: _clearToken,
    };
})();

export default LocalStorageServices;
